import { render, staticRenderFns } from "./historyDetails.vue?vue&type=template&id=7e1988cc&"
import script from "./historyDetails.vue?vue&type=script&lang=js&"
export * from "./historyDetails.vue?vue&type=script&lang=js&"
import style0 from "./historyDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports